import DashboardClass from "@/utils/dashboard_class.ts";
import useLoans from "@/hooks/loans.ts";
import PlaneSuccessTemplate from "@/pages/success_screens/PlaneSuccessTemplate.tsx";
import {useParams} from "react-router-dom";


const SuccessCrLine = () => {
    const loan = useLoans()
    const {urn} = useParams()

    return (
        <PlaneSuccessTemplate
            upd={loan.updateUserLoans}
            nav={DashboardClass.dashboard_routes.CreditLine + `/${urn}`}
        />
    )
}

export default SuccessCrLine